// extracted by mini-css-extract-plugin
export default {"landingWrap":"landing_landingWrap__b5WYl","landingContent":"landing_landingContent__2C+Vg","gradient":"landing_gradient__C7ZMQ"};